import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-assessors-stop',
  templateUrl: 'assessors-stop.component.html',
  styleUrls: ['./assessors-stop.component.less', '../../../shared/common.less'],
})

export class AssessorsStopComponent implements OnInit {
  @Input() isValidated: boolean = false;

  @Output() inviteAssessorsEvent = new EventEmitter();
  
  ngOnInit(): void {
  }
}
